import React from "react";
import Select, { ESelectSize } from "../../../Form/Select/Select";
import Quantifier from "../../../Foundation/Quantifier/Quantifier";
import clsx from "clsx";

interface IProductLineQuantifierProps {
  count: number;
  options: any;
  isMobile?: boolean;
  onChange?: (value: number) => void;
  loading?: boolean;
  max?: number;
}
const ProductLineQuantifier = ({
  count,
  options,
  isMobile,
  onChange,
  loading,
  max,
}: IProductLineQuantifierProps) => {
  return (
    <Quantifier
      className={clsx({ "ro-quantifier--empty": !count }, "ro-pr-bl__qty")}
      // addOnly={isMenu}
      onChange={onChange}
      async={true}
      useMobileTemplate={true}
      quantity={count}
      removeProductLabel={""}
      addProductLabel={""}
      loading={loading}
      variant="light"
      maxQuantity={max}
    />
  );
};
export default ProductLineQuantifier;
